export default {
    settingsDriverStatus_name: "Name",
    "settingsDriverStatus_clockIn": "Clock in",
    "settingsDriverStatus_clockOut": "Clock Out",
    "settingsDriverStatus_meakbegin": "Meal Break Begin",
    "settingsDriverStatus_meakEnd": "Meal Break End",
};